<template>
    <Home fit="cover">
    <!-- <Home fit="contain"> -->
        <template #picture>
            <!-- background -->
            <source media="(orientation: portrait)" srcset="../assets/img/titelbild_004_aw.jpg">
            <source media="(orientation: landscape)" srcset="../assets/img/titelbild_004_aw.jpg">
        </template>
            <template #headline>Was in Cannabis steckt</template>
            <template #subline>So wirkt es im Körper</template>
        <!-- <template #text>
            <p>Entdecke die älteste Nutz- und Heilpflanze.</p>
            <p>Was passiert im Körper?</p>
        </template> -->
        <template #update>
            <br>01.04.2024
        </template>
    </Home>
</template>

<script>
    export default {
        name: 'home',
        babylonState: {
            camera: {
                position: [0, 1, 10],
                target: [0, 2, 0],
                radiusLimits: [5, 100],

                useAutoRotationBehavior: true,
                idleRotationSpeed: 0.05,
            },
        },
        babylonReady: function ()
        {

        },
        // methods: {
        //     next: function () {
        //         this.$tracking.navigationClick('Start');
        //         this.$eventBus.$emi  t('nextPage');
        //     }
        // },
    }
</script>

<style lang="scss">

    .home {

        // change default opacity: 0.35
        .home__background {

            opacity: .8;
        }
        // change default object-position: unset (50% 50%)  / Für Portrait ist nur der x-Wert relevant, für Landscape nur der y-Wert. / Einheit entweder in "%" oder "px"
        .home__background img.o-fit {

            //object-position: 50% 0%;
            //
            //@media (orientation: landscape) {
            //
            //    object-position: 0% 50%;
            //}
        }
    }

</style>
